import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

import { getSetting } from '../helpers/Settings';

const Hotspot = ({ id }) => {
  const hotspots = getSetting('hotspots') || [];
  const h = hotspots.find(hs => (hs.id === id));
  if (!h) {
    return null;
  }

  const generateStyles = () => {
    const el = $(h.selector);
    if (!el) {
      return { display: 'none' };
    }

    el.css('position', 'relative').append($(`#${h.id}`));

    const styles = { ...h.styles };
    return styles;
  };

  return (
    <span key={h.id} id={h.id} className={`highlight-spot highlight-spot-${h.color_class}`} style={generateStyles(h)} />
  );
};

Hotspot.propTypes = {
  id: PropTypes.string.isRequired,
};

export default Hotspot;
